import { ReactComponent as FrontLogoIcon } from '@/assets/images/svg/logos/front/front-logo-icon.svg';
import {
  Heading,
  Logo,
  Section,
  StyledTable,
  TableHeader,
  Wrapper,
} from '@/components/tables/CompetitorComparisonTable/components';
import { FC, ReactNode } from 'react';

type Row = {
  enabled: boolean;
  text: string;
};

interface CompetitorComparisonTableProps {
  heading?: string;
  frontDescription?: string;
  frontRows: Row[];
  competitorLogo?: ReactNode;
  competitorName: string;
  competitorDescription?: string;
  competitorRows: Row[];
}

const CompetitorComparisonTable: FC<CompetitorComparisonTableProps> = (props) => {
  return (
    <Section>
      {props.heading && <Heading id="competitor-comparison-heading">{props.heading}</Heading>}

      <Wrapper>
        <StyledTable
          columns={[
            {
              header: (
                <TableHeader>
                  {props.competitorLogo && (
                    <Logo>
                      <FrontLogoIcon />
                    </Logo>
                  )}

                  <h4>Front</h4>

                  {props.frontDescription && <p>{props.frontDescription}</p>}
                </TableHeader>
              ),
              rows: props.frontRows,
            },
            {
              header: (
                <TableHeader>
                  {props.competitorLogo && <Logo>{props.competitorLogo}</Logo>}

                  <h4>{props.competitorName ?? ''}</h4>

                  {props.competitorDescription && <p>{props.competitorDescription}</p>}
                </TableHeader>
              ),
              rows: props.competitorRows,
            },
          ]}
        />
      </Wrapper>
    </Section>
  );
};

export default CompetitorComparisonTable;
